// src/components/AnimateChildrenOnScroll.tsx
import React from 'react';
import AnimatedOnScroll from './AnimateOnScroll';


interface AnimateChildrenOnScrollProps {
  children: React.ReactNode;
  animationClass: string;
  threshold?: number;
  rootMargin?: string;
  className?: string;
}

const AnimateChildrenOnScroll: React.FC<AnimateChildrenOnScrollProps> = ({
  children,
  animationClass,
  threshold,
  rootMargin,
  className,
}) => {
  return (
    <>
      {React.Children.map(children, (child, index) => {
        if (React.isValidElement(child)) {
          return (
            <AnimatedOnScroll
              key={child.key || index}
              animationClass={animationClass}
              threshold={threshold}
              rootMargin={rootMargin}
              className={className}
            >
              {child}
            </AnimatedOnScroll>
          );
        }
        return child;
      })}
    </>
  );
};

export default AnimateChildrenOnScroll;
